import React from 'react'
import { AppContainer, Header } from '@templatean/shared/components'
import TemplateList from '../components/TemplateList'

const TemplatesPage: React.FC = () => {
  return (
    <AppContainer>
      <Header 
        title="Templates"
        subtitle="Browse and manage your document templates"
      />
      
      <div className="page-content">
        <TemplateList onSelect={(template) => {
          console.log('Template selected:', template)
          // Navigate back to document with template
        }} />
      </div>
    </AppContainer>
  )
}

export default TemplatesPage